(function ($) {
  function handleLoader($promoCard) {
    var $loader = $promoCard.find('#loader');
    var $rowWrap = $promoCard.find('.row-wrap');
    if ($promoCard.find('.col-three').length > 0) {
      $promoCard.css({"opacity": "1"});
      $loader.hide();
      $rowWrap.css({"opacity": "1"});
    } else {
      $loader.show();
      $rowWrap.css({"opacity": "0"});
    }
  }
  
  $(window).on('load', function () {
    if ($('.promo-card .col-three').length > 3) {
      $('.promo-card .row-wrap').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplaySpeed: 6000,
        speed: 2000,
        infinite: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              draggable: true,
            }
          },
          {
            breakpoint: 596,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }

    $('.promo-card').each(function() {
      var $promoCard = $(this);
      handleLoader($promoCard);
      $promoCard.find(".text-wrap h6").dotdotdot({
        height: 45,
        fallbackToLetter: true,
        watch: true,
      });

      $promoCard.find('.col-three').each(function () {
        $(this).find('.name-date').eq(1).find('a').text(function (index, currentText) {
          if ($(this).text().length > 6) {
            return currentText.substr(0, 7) + '...';
          }
        });
      });

      $promoCard.find(".detail-wrapper .author-info .name-date").each(function () {
        $(this).find(".we-author, .we-editor, .we-contributor").clone().appendTo($(this).find(".tooltip"));
      });
    });
  });
})(jQuery);


var timer = 10000;
setTimeout(function() {
  function isEllipsisActive(e) {
    return (e.offsetWidth < e.scrollWidth);
  }
  var elementList = document.querySelectorAll('.we2022 .promo-card .detail-wrapper .author-info .name-date .name-tag');
  for (var idx = 0; idx < elementList.length; idx++) {
    if (isEllipsisActive(elementList.item(idx))) {
      elementList.item(idx).parentElement.classList.add("ellipsis-active");
    }
  }
}, timer);